import React from 'react';
import {Modal} from 'react-bootstrap';
import Loader from '../utils/Loader';
import {AvanzarDeEtapaView} from './AvanzarDeEtapaView';

function ModalCambioEtapaV2({
  isModalCambioEtapaShown,
  hideModalCambioEtapa,
  showModalCambioEtapa,
  etapasOptions,
  oportunidad,
  candidato,
  etapasById,
  candidatoIdNumerico,
  accion,
  onSuccess,
  onError,
  token,
  oportunidadId,
}) {
  const accionEsValida = ['avance', 'descarte'].includes(accion);

  return (
    <Modal
      show={isModalCambioEtapaShown}
      style={{opacity: 1}}
      onHide={hideModalCambioEtapa}
      onShow={showModalCambioEtapa}>
      {!accionEsValida && <Loader />}
      {accionEsValida && (
        <>
          <Modal.Header>
            <Modal.Title>
              {accion === 'avance' ? 'Avance de etapa' : 'Descartar candidato'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AvanzarDeEtapaView
              onSuccess={onSuccess}
              onError={onError}
              etapasOptions={etapasOptions}
              oportunidad={oportunidad}
              candidato={candidato}
              etapasById={etapasById}
              token={token}
              oportunidadId={oportunidadId}
              candidatoIdNumerico={candidatoIdNumerico}
              accion={accion}
            />
          </Modal.Body>
        </>
      )}
    </Modal>
  );
}

export {ModalCambioEtapaV2};
